module.exports = __webpack_public_path__ + "static/media/Perc1.8d6d66d2.wav";